import { getUserRecommendations } from '@atlaskit/smart-user-picker';
var MAX_RESULTS_USERS = 2;
export var ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
export var getUserAndTeamSearchResults = function getUserAndTeamSearchResults(_ref) {
  var query = _ref.query,
    cloudId = _ref.cloudId,
    orgId = _ref.orgId,
    _ref$principalId = _ref.principalId,
    principalId = _ref$principalId === void 0 ? 'Context' : _ref$principalId,
    intl = _ref.intl;
  return getUserRecommendations({
    searchQueryFilter: ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
    includeUsers: true,
    includeGroups: false,
    includeTeams: true,
    context: {
      contextType: 'confluence_search-dialog',
      principalId: principalId,
      productKey: 'confluence',
      siteId: cloudId,
      organizationId: orgId
    },
    maxNumberOfResults: MAX_RESULTS_USERS,
    query: query
  }, intl);
};